export const DO_LOGIN = "login/adfs";
export const DO_LOGOUT = "DO_LOGOUT";
